<template>
  <v-tooltip :location="location || 'bottom'" :class="className || 'w-75'">
    <template #activator="{ props }">
      <v-icon :class="iconClassName || 'ml-2'" color="grey" v-bind="props">
        mdi-help-circle-outline
      </v-icon>
    </template>
    {{ message }}
  </v-tooltip>
</template>

<script lang="ts" setup>
interface Props {
  message: string;
  location?: 'bottom' | 'top' | 'left' | 'center';
  className?: string;
  iconClassName?: string;
}
defineProps<Props>();

</script>
